import React, { useRef } from "react";
import PropTypes from "prop-types";
import { VideoPlayerContainer } from "orion-components/CBComponents";
import { v4 as uuidv4 } from "uuid";

const BorderLessCameraCard = (props) => {
	const {
		camera,
		contextId,
		entityType,
		readOnly,
		playbackStartTime,
		playBarValue,
		playbackPlaying,
		currentReplayMedia,
		addReplayMedia,
		removeReplayMedia,
		expanded,
		isOnAlertProfile,
		isOnProfile,
		alertDateTime,
		defaultToRecorded,
		playbackStartOffset,
		initialRecordedDuration,
		initialRecordedTimeUnit,
		disableVideoModeToggle,
		dockedItemId,
		isDockedVideoTour,
		namePrefix,
		dwellTime
	} = props;
	const instanceIdRef = useRef(uuidv4());

	return (
		<div style={{ width: "100%", height: "100%", marginBottom: 10 }}>
			<VideoPlayerContainer
				camera={camera}
				instanceId={instanceIdRef.current}
				entityId={contextId}
				entityType={entityType}
				namePrefix={namePrefix}
				dwellTime={dwellTime}
				dockedItemId={dockedItemId}
				isDockedVideoTour={isDockedVideoTour}
				readOnly={readOnly}
				playbackStartTime={playbackStartTime}
				playBarValue={playBarValue}
				playbackPlaying={playbackPlaying}
				currentReplayMedia={currentReplayMedia}
				addReplayMedia={addReplayMedia}
				removeReplayMedia={removeReplayMedia}
				expanded={expanded}
				isOnAlertProfile={isOnAlertProfile}
				isOnProfile={isOnProfile}
				alertDateTime={alertDateTime}
				defaultToRecorded={defaultToRecorded}
				playbackStartOffset={playbackStartOffset}
				initialRecordedDuration={initialRecordedDuration}
				initialRecordedTimeUnit={initialRecordedTimeUnit}
				disableVideoModeToggle={disableVideoModeToggle}
			/>
		</div>
	);
};

BorderLessCameraCard.propTypes = {
	camera: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
	contextId: PropTypes.string.isRequired,
	entityType: PropTypes.string.isRequired,
	readOnly: PropTypes.bool,
	playbackStartTime: PropTypes.number,
	playBarValue: PropTypes.number,
	playbackPlaying: PropTypes.bool,
	currentReplayMedia: PropTypes.object,
	addReplayMedia: PropTypes.func,
	removeReplayMedia: PropTypes.func,
	expanded: PropTypes.bool,
	isOnAlertProfile: PropTypes.bool,
	alertDateTime: PropTypes.any,
	defaultToRecorded: PropTypes.bool,
	playbackStartOffset: PropTypes.number,
	initialRecordedDuration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	initialRecordedTimeUnit: PropTypes.string,
	disableVideoModeToggle: PropTypes.bool,
	dockedItemId: PropTypes.string,
	isDockedVideoTour: PropTypes.bool,
	namePrefix: PropTypes.string,
	dwellTime: PropTypes.number
};

BorderLessCameraCard.defaultProps = {
	readOnly: false,
	playbackStartTime: 0,
	playBarValue: 0,
	playbackPlaying: false,
	currentReplayMedia: null,
	addReplayMedia: () => {},
	removeReplayMedia: () => {},
	isOnProfile: false,
	alertDateTime: "",
	defaultToRecorded: false,
	disableVideoModeToggle: false,
	dockedItemId: null,
	isDockedVideoTour: false,
	namePrefix: null,
	dwellTime: null
};

export default BorderLessCameraCard;
